import React, { useEffect, useState } from "react";
import {
  Box,
  Avatar,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
  withStyles,
  Divider,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import CustomInput from "../../../../../Components/CustomInput";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import EditSetup from "./EditSetup";
import DataService from "../../../../../Service";
import CircularIndeterminate from "../../../../../Components/Loader";
import { ObjectToFormdata } from "../../../../../Common/Utils/common_utils";
import DataClient from "../../../../../Service/general_data_service";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { useDispatch } from "react-redux";

function CompetencySetUp(props) {
  const [open, setOpen] = React.useState(false);
  const [confirmationDialogOpen, setConfirmationDialogOpen] =
    React.useState(false);
  const [userData, setUserData] = useState({ name: "" });
  const [currentData, setCurrentData] = React.useState("");
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [action, setAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const dispatch = useDispatch();

  const columns = [
    { field: "name", title: "Competencies" },
    { field: "description", title: "Description" },
  ];
  const options = {
    cellStyle: { fontSize: 14 },
    actionsColumnIndex: -1,
    toolbar: false,
    search: false,
    pageSize: pageSize,
    total: totalCount,
    emptyRowsWhenPaging: false,
    pageSizeOptions: [20, 50, 75, 100],
    headerStyle: {
      position: "sticky",
      top: "0",
      fontWeight: "bold",
    },
    maxBodyHeight: "600px",
  };

  const actions = [
    // {
    //     icon: () => <EditIcon fontSize="small" />,
    //     tooltip: 'Edit',
    //     onClick: (event, rowData) => {
    //         console.log(`rowData`, event)
    //         setCurrentData(rowData);
    //         setAction('edit');
    //     }
    // },
    // {
    //     icon: () => <DeleteIcon fontSize="small" />,
    //     tooltip: 'Delete',
    //     onClick: (event, rowData) => {
    //         setCurrentData(rowData);
    //         handleClickConfirmationOpen()
    //     }
    // },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setUserData({ ...userData, name: "" });

    setOpen(false);
  };
  const handleClickConfirmationOpen = () => {
    setConfirmationDialogOpen(true);
  };

  const handleConfirmationClose = () => {
    setConfirmationDialogOpen(false);
  };
  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };

  useEffect(() => getCompetency(), []);
  useEffect(() => getCompetency(), [page, pageSize, props.organisationId]);

  const getCompetency = () => {
    setLoading(true);
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      organisation_id: props.organisationId,
    };
    DataService.getDirectData(
      "organisation_metrics/list_organisation_metric",
      params
    )
      .then((res) => {
        setLoading(false);
        tableData.length = 0;
        setTableData(tableData.concat(res.organisation_metric));
        setTotalCount(res.total_count);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const addCompetency = (event) => {
    setLoading(true);
    var postData = {
      organisation_id: props.organisationId,
      name: userData.name,
    };

    DataService.createData({ ...postData }, "add_competency")
      .then((res) => {
        console.log(`res`, res);
        setLoading(false);
        getCompetency();
        handleClose();
        setUserData({ ...userData, name: "" });
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const deleteCompetency = (event) => {
    setLoading(true);
    DataClient.remove("competencies/" + currentData.id)
      .then((res) => {
        console.log(`res`, res);
        setLoading(false);
        getCompetency();
        dispatch(showSnackbar("Success", ["Competency deleted successfully"]));

        handleConfirmationClose();
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const afterEdit = (params) => {
    getCompetency();
  };

  return (
    <Box p={3}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs="8">
          <Grid container direction="row" spacing={1}>
            <Grid item xs="12">
              <Typography
                variant="h1"
                color="secondary"
                style={{ paddingBottom: "16px" }}
              >
                <Box fontWeight="fontWeightBold">Competencies</Box>
              </Typography>
            </Grid>
            {/* <Grid item xs={12}>
                        <Box textAlign="right" mb={3}>
                            <Button disableElevation variant="contained" color="secondary" onClick={handleClickOpen}>+ Add Competency</Button>
                        </Box>
                    </Grid> */}
            <Grid item xs="12">
              <MaterialTable
                title=""
                columns={columns}
                actions={actions}
                data={tableData}
                options={options}
                isLoading={isLoading}
                totalCount={totalCount}
                page={page}
                onChangeRowsPerPage={(pageSize) => {
                  setPageSize(pageSize);
                }}
                onChangePage={(page) => {
                  setPage(page);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth="100%"
          maxWidth={maxWidth}
          style={{ padding: 24 }}
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            <Box>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Add New Competency
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <Box p={3}>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginTop: 20 }}
              >
                <Grid item xs={4}>
                  <Typography variant="h2">
                    <Box>Enter Competency Name</Box>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomInput
                    id="name"
                    variant="outlined"
                    placeholder="Competency Name"
                    parentcall={setInputState}
                    value={userData.name}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Box px={3} py={2}>
              <Button
                disableElevation
                variant="contained"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="secondary"
                onClick={addCompetency}
                style={{ marginLeft: 10 }}
              >
                Add
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
      <Box>
        <Dialog
          onClose={handleConfirmationClose}
          aria-labelledby="confirmation-dialog-title"
          open={confirmationDialogOpen}
          maxWidth={maxWidth}
        >
          <DialogContent>
            <Box p={4}>
              <Typography variant="h2">
                <Box textAlign="center">Are you sure to delete?</Box>
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions
            disableSpacing={true}
            style={{ justifyContent: "center" }}
          >
            <Box px={4} pb={2}>
              <Button
                disableElevation
                variant="contained"
                onClick={handleConfirmationClose}
              >
                No
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="secondary"
                onClick={deleteCompetency}
                style={{ marginLeft: 10 }}
              >
                Yes
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
      {action == "edit" && (
        <EditSetup
          openDialogFlag={true}
          parentDialogEvent={setAction}
          currentData={currentData}
          afterEdit={afterEdit}
        />
      )}
      {loading && <CircularIndeterminate />}
    </Box>
  );
}

export default CompetencySetUp;
